/**
 * Runtime environment config. Values are injected via env-config.js
 * (generated by docker-entrypoint.sh from Cloud Run env vars at container
 * startup, before nginx starts serving). This lets one built portal image
 * be promoted by digest across staging/UAT/production (nova-strata-promote.yaml)
 * without rebuilding -- if these were baked in at `vite build` time instead
 * (via VITE_* build args), every promoted environment would inherit
 * whichever backend URL staging happened to build with.
 *
 * In local dev (`vite dev`), env-config.js ships empty and the exported
 * constants below fall back to `import.meta.env.VITE_*`.
 */

interface EnvConfig {
  API_BASE_URL: string;
  GOOGLE_MAPS_API_KEY: string;
}

declare global {
  interface Window {
    __ENV__?: Partial<EnvConfig>;
  }
}

function getEnv(key: keyof EnvConfig): string {
  return window.__ENV__?.[key] || '';
}

export const API_BASE_URL =
  getEnv('API_BASE_URL') || import.meta.env.VITE_API_URL || 'http://localhost:4001';

export const GOOGLE_MAPS_API_KEY =
  getEnv('GOOGLE_MAPS_API_KEY') || import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';
